// extracted by mini-css-extract-plugin
module.exports = {"infoMessageBox":"infoMessage_infoMessageBox__CHKJZ","icon":"infoMessage_icon__jjvQY","message":"infoMessage_message__k7YK1"};